import "./message.css.ts.vanilla.mjs";
var a = "p273__message-8439_fc51e2acc__5o2gah0";
export {
  a as messageStyle
};
//# sourceMappingURL=message.mjs.map
